import { Flex, Box } from "@chakra-ui/react";
import appDebugger from "../AppDebugger";
import ListButton from "src/components/ListButton";
import NavigationBar from "src/components/NavigationBar";

const remote = window.require("@electron/remote");

export default function DebugSettings({ onBack }) {
  function toggleDebugger() {
    if (appDebugger.state === "disabled") {
      appDebugger.enable();
    } else appDebugger.disable();
  }

  return (
    <>
      <NavigationBar headingKey="debugSettings" onBack={onBack} />
      <Flex
        flexWrap="wrap"
        mt="16px"
        mr="-24px"
        py="8px"
        px="24px"
        bg="surfaceElevated1"
      >
        <Box width="50%" pr="24px" mb="16px">
          <ListButton
            width="280px"
            labelKey="enableConsole"
            onClick={() => remote?.getCurrentWebContents?.().openDevTools?.()}
          />
        </Box>

        <Box width="50%" pr="24px" mb="16px">
          <ListButton
            width="280px"
            labelKey="webrtcInfo"
            onClick={toggleDebugger}
          />
        </Box>
      </Flex>
    </>
  );
}
